<!-- Initial loader -->
<app-loader *ngIf="(profileState | async).profileDetail === null" message="Loading audit report..."></app-loader>

<!-- Profile Header -->
<section class="audit-page" *ngIf="(profileState | async).profileDetail !== null">
  <app-breadcrumbs type="profileReport"></app-breadcrumbs>

  <div class="profile-header-card">
    <app-loader *ngIf="!(profileState | async).loader['audit']['detail']" size="sm"></app-loader>

    <div class="profile-header" [class.dimmed]="!(profileState | async).loader['audit']['detail']">
      <div class="profile-identity">
        <a class="avatar-wrapper" href="{{'https://www.instagram.com/' + (profileState | async).profileDetail.username}}" target="_blank">
          <img class="avatar-img"
               [src]="(profileState | async).profileDetail.profile_pic_url"
               onerror="this.onerror=null;this.src='./assets/images/icons/face.png'"
               alt="Profile avatar"/>
          <span class="platform-badge instagram">
            <i class="bi bi-instagram"></i>
          </span>
        </a>
        <div class="profile-meta">
          <h1 class="username">
            <a href="{{'https://www.instagram.com/' + (profileState | async).profileDetail.username}}" target="_blank">
              &#64;{{(profileState | async).profileDetail.username}}
            </a>
          </h1>
          <p class="fullname" *ngIf="(profileState | async).profileDetail.full_name">{{(profileState | async).profileDetail.full_name}}</p>
          <p class="generated-date" *ngIf="(profileState | async).audit !== null && (profileState | async).audit.status == 2">
            <i class="bi bi-calendar3"></i>
            Generated on {{(profileState | async).audit.added_time * 1000 | date}}
          </p>
        </div>
      </div>

      <div class="key-stats">
        <div class="stat-box">
          <span class="stat-number">{{(profileState | async).profileDetail.media_count | shortcutNumbers}}</span>
          <span class="stat-label">Posts</span>
        </div>
        <div class="stat-box">
          <span class="stat-number">{{(profileState | async).profileDetail.followed_by | shortcutNumbers}}</span>
          <span class="stat-label">Followers</span>
        </div>
        <div class="stat-box">
          <span class="stat-number">{{(profileState | async).profileDetail.follows | shortcutNumbers}}</span>
          <span class="stat-label">Following</span>
        </div>
        <div class="stat-box">
          <app-audit-no-mention type="value">
            <span class="stat-number" *ngIf="((profileState | async).audit !== null) && (profileState | async).followerEngage !== null">
              {{(profileState | async).followerEngage.engage_count | number:'1.2'}}%
            </span>
          </app-audit-no-mention>
          <span class="stat-label">
            ER
            <a data-tooltip="Percent of followers who liked or commented the post (last 30 days)">
              <i class="bi bi-info-circle"></i>
            </a>
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- Processing State: Full Report -->
  <div class="status-card" *ngIf="(profileState | async).audit !== null && (profileState | async).audit.status === 1 && (profileState | async).profileProgress.data.percent !== 33">
    <div class="status-icon pulse">
      <i class="bi bi-hourglass-split"></i>
    </div>
    <h3>Report is being prepared</h3>
    <p class="text-muted">We're analyzing posts, likes, and audience in real time. This can take up to 10 hours.</p>
    <div class="progress-track" *ngIf="(profileState | async).profileProgress.data.percent !== 0">
      <div class="progress-fill"
           [ngStyle]="{width: ((profileState | async).profileProgress.data !== undefined ? (profileState | async).profileProgress.data.percent : 0) + '%'}">
      </div>
      <span class="progress-label">{{(profileState | async).profileProgress.data !== undefined ? (profileState | async).profileProgress.data.percent : 0}}%</span>
    </div>
  </div>

  <!-- Processing State: No Posts -->
  <div class="status-card warning" *ngIf="(profileState | async).audit !== null && (profileState | async).audit.status === 1 && (profileState | async).audit.bio.mention_count !== undefined && (profileState | async).audit.bio.mention_count === 0">
    <div class="status-icon">
      <i class="bi bi-exclamation-triangle"></i>
    </div>
    <h3>No posts in the last 30 days</h3>
    <p class="text-muted">Report contains only audience data. Posts analysis is not included.</p>
  </div>

  <!-- Processing State: Trial -->
  <div class="status-card" *ngIf="(profileState | async).audit !== null && (profileState | async).audit.status === 0 && (profileState | async).profileProgress !== null && (profileState | async).profileProgress.media.percent < 100">
    <div class="status-icon pulse">
      <i class="bi bi-lightning-charge"></i>
    </div>
    <h3>Generating your trial report</h3>
    <p class="text-muted">We're analyzing posts in real time &mdash; this may take a minute.</p>
    <div class="progress-track">
      <div class="progress-fill" [ngStyle]="{width: trialPercent + '%'}"></div>
      <span class="progress-label">{{trialPercent}}%</span>
    </div>
  </div>

  <!-- Analysis Sections (status > 0) -->
  <div class="analysis-sections" *ngIf="id === undefined || ((profileState | async).audit !== null && (profileState | async).audit.status > 0)">
    <app-followers-reliability type="1" class="w-100" [auditType]="type()" [id]="id"></app-followers-reliability>
    <app-followers-demography type="1" class="w-100" [auditType]="type()" [id]="id"></app-followers-demography>
    <app-followers-location type="1" class="w-100" [auditType]="type()" [id]="id"></app-followers-location>
    <app-profile-analyze class="w-100" [auditType]="type()" [id]="id"></app-profile-analyze>
  </div>

  <!-- Engagement Rate Chart -->
  <div class="report-card">
    <div class="report-card-header">
      <h3>
        Engagement rate by days
        <a data-tooltip="Average engagement rate - checked per day (graph showing dynamics in the last 30 days)">
          <i class="bi bi-info-circle"></i>
        </a>
      </h3>
    </div>
    <app-audit-no-mention type="chart" name="Engagement rate">
      <app-loader *ngIf="!(profileState | async).loader['audit']['followerEngage']" size="sm"></app-loader>
      <div class="chart-container" [class.dimmed]="!(profileState | async).loader['audit']['followerEngage']">
        <div *ngIf="chartsFollowerEngage !== undefined">
          <div [chart]="chartsFollowerEngage[0]"></div>
        </div>
      </div>
    </app-audit-no-mention>
  </div>

  <!-- Engagement Summary -->
  <div class="report-card" *ngIf="interactionAvg !== undefined && (profileState | async).audit !== null && (profileState | async).audit.status !== 0">
    <div class="report-card-header with-stats">
      <div>
        <h3>
          Engagement
          <a data-tooltip="Average engagement of the audited profile - number of interactions versus number of followers">
            <i class="bi bi-info-circle"></i>
          </a>
        </h3>
        <p class="header-subtitle">Compared to average values for similar accounts</p>
      </div>
      <div class="header-metrics">
        <div class="metric-item">
          <app-audit-no-mention type="value">
            <span class="metric-value" *ngIf="(profileState | async).followerEngage !== null">{{(profileState | async).followerEngage.like_avg | separateNumbers}}</span>
          </app-audit-no-mention>
          <span class="metric-label">
            Avg likes
            <a data-tooltip="Average number of likes per post"><i class="bi bi-info-circle"></i></a>
          </span>
        </div>
        <div class="metric-item">
          <app-audit-no-mention type="value">
            <span class="metric-value" *ngIf="(profileState | async).followerEngage !== null">{{(profileState | async).followerEngage.comment_avg | separateNumbers}}</span>
          </app-audit-no-mention>
          <span class="metric-label">
            Avg comments
            <a data-tooltip="Average number of comments per post"><i class="bi bi-info-circle"></i></a>
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- Engagement Rate Comparison -->
  <div class="report-card engage-comparison">
    <div class="report-card-header">
      <h3>
        <i class="bi bi-bar-chart-line"></i>
        Engagement rate by followers
        <a data-tooltip="Table presenting ranges of followers and average engagement">
          <i class="bi bi-info-circle"></i>
        </a>
      </h3>
      <p class="header-subtitle">How does this profile compare to the industry average?</p>
    </div>

    <app-loader *ngIf="!(profileState | async).loader['audit']['followerEngage']" size="sm"></app-loader>

    <div [class.dimmed]="!(profileState | async).loader['audit']['followerEngage']">
      <app-audit-no-mention type="chart" name="Average engagement rate table">

        <!-- Legend -->
        <div class="bar-legend">
          <span class="bar-legend-item"><span class="bar-legend-dot avg"></span> Industry average</span>
          <span class="bar-legend-item"><span class="bar-legend-dot profile"></span> This profile</span>
        </div>

        <!-- Bars -->
        <div class="engage-bars">
          <div class="engage-bar-row" *ngFor="let engage of engagementStat" [class.active-row]="engage.profile !== undefined">

            <!-- Label -->
            <div class="bar-label">
              <span class="bar-range">{{engage.description}}</span>
              <span class="bar-followers-label">followers</span>
            </div>

            <!-- Bars area -->
            <div class="bar-tracks">
              <!-- Average bar -->
              <div class="bar-track">
                <div class="bar-fill avg" [ngStyle]="{width: 'max(24px, ' + (engage.engage / 6 * 100) + '%)'}"></div>
                <span class="bar-value-outside">{{engage.engage}}%</span>
              </div>

              <!-- Profile bar (only for matching range) -->
              <div class="bar-track" *ngIf="engage.profile !== undefined">
                <div class="bar-fill profile"
                     [class.above]="engage.profile.engage > engage.engage"
                     [class.below]="engage.profile.engage <= engage.engage"
                     [ngStyle]="{width: engage.profile.engage > 0 ? 'max(24px, ' + (engage.profile.engage / 6 * 100) + '%)' : '0'}"></div>
                <span class="bar-value-outside" *ngIf="engage.profile.engage > 0">{{engage.profile.engage | number:'1.2'}}%</span>
                <span class="bar-loading" *ngIf="engage.profile.engage == 0">Loading...</span>
              </div>

              <!-- Result indicator -->
              <div class="bar-result" *ngIf="engage.profile !== undefined && engage.profile.engage > 0">
                <span class="result-chip above" *ngIf="engage.profile.engage > engage.engage">
                  <i class="bi bi-arrow-up-short"></i>
                  {{((engage.profile.engage - engage.engage) / engage.engage * 100) | number:'1.0-0'}}% above avg
                </span>
                <span class="result-chip below" *ngIf="engage.profile.engage <= engage.engage">
                  <i class="bi bi-arrow-down-short"></i>
                  {{((engage.engage - engage.profile.engage) / engage.engage * 100) | number:'1.0-0'}}% below avg
                </span>
              </div>
            </div>

            <!-- Profile indicator -->
            <div class="profile-indicator" *ngIf="engage.profile !== undefined && (profileState | async).profileDetail !== null">
              <img [src]="(profileState | async).profileDetail.profile_pic_url" class="indicator-avatar" onerror="this.onerror=null;this.src='./assets/images/icons/face.png'"/>
              <i class="bi bi-caret-left-fill indicator-arrow"></i>
            </div>
          </div>
        </div>
      </app-audit-no-mention>
    </div>
  </div>

  <!-- Trial Analysis Sections (status === 0) -->
  <div class="analysis-sections" *ngIf="((profileState | async).audit !== null && (profileState | async).audit.status === 0)">
    <app-followers-reliability type="1" class="w-100" [auditType]="type()" [id]="id"></app-followers-reliability>
    <app-user-rank [auditType]="type()" [id]="id"></app-user-rank>
    <app-profile-analyze class="w-100" [auditType]="type()" [id]="id"></app-profile-analyze>
    <app-followers-demography type="1" class="w-100" [auditType]="type()" [id]="id"></app-followers-demography>
    <div [ngClass]="!((profileState | async).audit !== null && (profileState | async).audit.status) ? 'mb-5' : ''">
      <app-followers-location type="1" class="w-100" [auditType]="type()" [id]="id"></app-followers-location>
    </div>
  </div>
</section>